import { render, staticRenderFns } from "./especieinfo.vue?vue&type=template&id=25cf6b28"
import script from "./especieinfo.vue?vue&type=script&lang=js"
export * from "./especieinfo.vue?vue&type=script&lang=js"
import style0 from "./especieinfo.vue?vue&type=style&index=0&id=25cf6b28&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports